import socialResponsibility from "@assets/images/about-us/social-responsibility.png";
import { trans } from "@mongez/localization";

/**
 * Social responsibility hero section
 * Displays the main title, description, and image
 */
export function SocialResponsibilityHero() {
  return (
    <div className="container mb-12 sm:mb-16 md:mb-18 lg:mb-20 3xl:mb-24">
      <h3 className="mb-6 sm:mb-8 md:mb-10 lg:mb-8 xl:mb-10 max-w-full text-2xl sm:text-3xl md:text-4xl lg:text-[42px] xl:text-5xl 2xl:text-6xl font-medium leading-tight sm:leading-snug md:leading-tight tracking-[-0.03rem] text-secondary">
        {trans("socialResponsibilityYearAfterYear")}
      </h3>
      <div className="flex flex-col gap-6 sm:gap-8 md:gap-10 lg:gap-8 xl:gap-10 lg:flex-row items-center lg:justify-between 3xl:gap-12">
        <div className="w-full lg:flex-1 lg:max-w-[60%] xl:max-w-[55%] space-y-3 sm:space-y-4 md:space-y-5 lg:space-y-4 xl:space-y-5 text-sm sm:text-base md:text-lg lg:text-lg xl:text-xl 2xl:text-2xl 3xl:text-3xl text-marine">
          <p>{trans("socialResponsibilityDescription1")}</p>
          <p>{trans("socialResponsibilityDescription2")}</p>
          <p>{trans("socialResponsibilityDescription3")}</p>
        </div>

        <div className="w-full lg:w-auto lg:flex-shrink-0">
          <img
            src={socialResponsibility}
            alt={trans("socialResponsibilityTitle")}
            className="w-full h-48 sm:h-56 md:h-64 lg:h-auto lg:w-[320px] xl:w-[400px] 2xl:w-[550px] 3xl:w-[650px] object-cover rounded-2xl sm:rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}
